import { render, staticRenderFns } from "./btn-secondary3.vue?vue&type=template&id=953b8ad8&scoped=true&"
import script from "./btn-secondary3.vue?vue&type=script&lang=js&"
export * from "./btn-secondary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953b8ad8",
  null
  
)

export default component.exports